import React from "react";
import NumberGuessGame from "./components/Game/NumberGuessGame";
import "./App.css";

function App() {
  return (
    <div className="App">
      <NumberGuessGame />
    </div>
  );
}

export default App;
